import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { IconModule } from '@shabic/icon';
import { UiModule } from '@shabic/ui';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, IconModule, UiModule, TranslateModule],
  exports: [AlertComponent],
})
export class AlertModule {}
